import React from 'react';
import { ButtonContainer } from './PrimaryButton.styles';

export interface PrimaryButtonProps {
  /**
   * Button content
   */
  children: React.ReactNode;
  /**
   * Optional onClick handler
   */
  onClick?: () => void;
  /**
   * Is the button disabled?
   */
  disabled?: boolean;
  /**
   * Full width button
   */
  fullWidth?: boolean;
  /**
   * Additional class name
   */
  className?: string;
  /**
   * Button variant
   */
  variant?: 'primary' | 'outline' | 'danger' | 'outline-black';
}

/**
 * Primary button component
 */
export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  onClick,
  disabled = false,
  fullWidth = true,
  className = '',
  variant = 'primary',
}) => {
  return (
    <ButtonContainer
      onClick={onClick}
      disabled={disabled}
      $fullWidth={fullWidth}
      className={className}
      $variant={variant}
    >
      <span>
        {children}
      </span>
    </ButtonContainer>
  );
};

export default PrimaryButton;
